var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'contact-person',
        `contact-person--image-${_vm.imagePosition}`,
        `contact-person--size-${_vm.size}`,
    ]},[(!_vm.hideImage)?_c('div',{staticClass:"contact-person__image",style:(`background-image: url(${_vm.image ? _vm.image : '/images/bio.jpg'});`)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contact-person__container"},[(_vm.name)?_c('p',{staticClass:"contact-person__name",domProps:{"innerHTML":_vm._s(_vm.name)}}):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"contact-person__description",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),_vm._t("detail")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }